<template>
    <!-- // !!!!!!!!!!!!!!!!!!!!!!!!!!!! 這是網頁版的充電站  ( 防止切來切去搞混 ) -->
	<div id="newsDetail" data-role="page">
        <!-- 未連接至網路的提醒 -->
        <div v-if="!closeOffline && isOffline" class="v3offline">
            <i class="icon-exclamation-mark-circle"></i>
            <p>未連接至網路</p>
            <div @click="closeOfflineHandle"><i class="icon-close"></i></div>
        </div>
		<!-- content -->
		<div class="newsDetail-content" id="v3newsDetail" data-position="fixed">
			<div class="detailWrap">
                <div class="detail-h">
					<span class="cgy-tag">{{News.type_name}}</span>
					<h3 :class="{'LargSize':fz_larg}">{{News.title}}</h3>
					<span class="article_date" :class="{'LargSize':fz_larg}">{{News.news_date}}</span>
				</div>
				<!-- 文章內容 -->
                <div class="detail-c">
                    <img class="mainImg" v-if="News.title_img !== ''" :src="News.title_img" />
                    <div class="mainImg" :style="{ height: '250px' }" v-if="News.title_img == ''"></div>
                    <div class="txtContent" :class="{'LargSize':fz_larg}">
                        <div v-for="(html, index) in News.content" :key="index">
                            <p v-if="html !== 'AD'" v-html="html"></p>
                            <div v-if="html === 'AD'">
                                <!-- 廣告部分 -->
                                <template>
                                    <script2 type="text/javascript" async="true" src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js" />
                                    <ins
                                        class="adsbygoogle"
                                        :style="'display:block; text-align:center;'"
                                        :data-ad-layout="'in-article'"
                                        :data-ad-format="'fluid'"
                                        :data-ad-client="'ca-pub-9449560331897859'"
                                        :data-ad-slot="'9862565468'"
                                        data-full-width-responsive='yes'
                                    />
                                    <script2 type="text/javascript"> (adsbygoogle = window.adsbygoogle || []).push({}); </script2>
                                </template>
                            </div>
                        </div>
					</div>
				</div>
				<!-- /文章內容 -->
				<!-- 公寓管理條例相關法條 -->
				<div class="detail-ref" v-if="MoreNewsRule.length !=0">
					<h4><i class="icon-article-pen"></i>公寓大廈管理條例相關法條</h4>
					<ul>
						<li v-for="(rule,rule_ind) in MoreNewsRule" :key="rule_ind"><router-link :to="{name:'legalRuleDetail', params:{ id:rule.rule_id}}">{{rule.rule_name}}</router-link></li>
					</ul>
				</div>
				<!-- /公寓管理條例相關法條 -->
                <div class="detail-source">
                    <h4>文章來源</h4>
                    <div class="logowrap">
                        <p class="s-name">{{News.legal_name}}</p>
                        <div class="logoImg" v-if="News.legal_logo != null">
                            <img :src="News.legal_logo" alt="">
                        </div>
                    </div>
                    <!-- 文章來源下的文章, 通常連到別人的官網裡去 -->
                    <div class="descwrap">
						{{News.about}}
                        <span class="more"
                            v-if="News.multiLink && News.multiLink !== '[]'"
                            v-on:click.prevent="windowsOpen(News.multiLink)"> <<查看更多</span>
					</div>
                </div>
			</div>
            <!--問卷-->
            <div class="detailWrap articleWrap questionnaire">
                <div class="detail-c">
					<div class="questionnaire">
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSetKmRasOJyXyx4XNOt8g_bFeUpytB5dTVdzRnPkAhAN_Ezzg/viewform">
                            <div class="img">
                            </div>
                            <div class="txt">
                                <span class="title">想看什麼快來許願吧！</span>
                                <p class="content">不管你想看甚麼,我們都幫你準備。</p>
                            </div>
                        </a>
                    </div>
                </div>
			</div>
            <!--/問卷-->
			<!-- 相關文章 -->
            <div class="detailWrap articleWrap" v-if="MoreNews.length>0">
                <div class="detail-c">
                    <h4 class="cgyTitle"><i class="titleIcon icon-article-pen"></i>相關文章</h4>
                    <a v-on:click="CleanGotoNewsPage(News.news_type)"><span class="moreBtn-rt">查看更多 ></span></a>
                    <!-- v3 -->
                    <div class="articleList">
                        <ul>
                            <li v-for="(news,MoreNews_ind) in MoreNews" :key="MoreNews_ind">
                                <a v-on:click="nextPage(news.news_id)">
                                <span class="articleTag">{{news.news_type}}</span>
                                <div class="articleContent">
                                    <div class="articleContentImg" v-if="news.title_img !== ''" v-lazy:background-image="news.title_img" ></div>
                                    <div class="articleContentImg" v-if="news.title_img == ''"></div>
                                    <span class="articleContentNote">{{news.title}}</span>
                                    <span class="articleContentIcon"><i class="icon-right-roundedline"></i></span>
                                </div>
                                </a>
                            </li>
                        </ul>
                        <div class="moreBtn" v-if="MoreNews_row<=this.MoreNews.length && this.MoreNews.length >=10">
                            <p class="loading-rotate"></p>
                            <p class="loading-tip">載入更多</p>
                        </div>
                    </div>
                </div>
			</div>
			<!-- /相關文章 -->
		</div>
		<!-- /content -->
        <!-- footer -->
        <!-- 神奇規則:
            1. 智生活開啟的下面那條一定要顯示 ( 可以視作有 token 就顯示 )
            2. 網頁用戶是沒辦法看到這條的 ( 假設他們都不會開啟 f12 自己設 )
            3. 未登入的智生活用戶按下讚推才會跳轉到 app 說要登入喔
        -->
        <div id="v3functionBar" class="qk-functionBar active" v-if="hasToken">
            <div :class="['qk-functionBar-wrap-col4']">
				<div v-on:click="SetRecommend(News.news_id,News.is_push)" :class="{active: News.is_push}"><span><i :class="[ News.is_push ? 'icon-like-full':'icon-like-line']"></i>推</span></div>
                <div v-on:click="SetFavorites(News.news_id,News.is_keep)" :class="{active: News.is_keep}"><span><i :class="[ News.is_keep ? 'icon-saved-full':'icon-saved-line']"></i>收藏</span></div>
                <div v-on:click="ChanegSize" :class="{active: fz_larg}"><span><i class="icon-font-size"></i>大小</span></div>
                <div @click="Share"><span><i class="icon-export"></i>分享</span></div>
                <!-- <ShareNetwork
                    network="line"
                    :url='shareURL'
                    :title="News.title || '智生活文章'"
                    :description="News.abstract_note || '智生活文章'"
                    :quote="News.type_name || '智生活文章'"
                ><div><span><i class="icon-export"></i>分享</span></div></ShareNetwork> -->
            </div>
        </div>
        <!-- 跟 APP 一樣的 Alert -->
        <div class="appAlertMask" @touchmove.prevent v-if="appAlertDisplay" @click="() => this.appAlertDisplay = !this.appAlertDisplay"></div>
        <div class="appAlert" v-if="appAlertDisplay">
            <div class="appAlertTitle">系統提示</div>
            <div class="appAlertNote">此功能限定會員使用，現在就加入會員吧！</div>
            <div class="appAlertButton">
                <span @click="backToApp">加入會員</span>
                <span @click="() => this.appAlertDisplay = !this.appAlertDisplay">暫時不用</span>
            </div>
        </div>
        <!-- /footer -->

        <favoritesToast
        :show="toastControl.show"
        :full="toastControl.full"
        :content="toastControl.content"
        :showTime="toastControl.showTime"
        @close="toastControl.show = false"
        ></favoritesToast>
        <!-- v3 無圖案 Toast -->
        <div v-show="v3Toast.show" class="v3Toast">{{v3Toast.text}}</div>
	</div>
</template>

<script lang="js">
// !!!!!!!!!!!!!!!!!!!!!!!!!!!! 這是網頁版的充電站  ( 防止切來切去搞混 )
import axios from 'axios'
import v3favoritesToast from '@/components/common/toast/v3favoritesToast';
import favoritesToast from '@/components/common/toast/favoritesToast';

// * 要怎麼知道誰是有認證的使用者 ( 可以使用推跟收藏 )
// * 使用者1 開智生活打開這個頁面 ( ＡＰＰ 注入裝置 token, 刪除舊有 token )
// * 使用者2 智生活以外打開分享的網址 ( 外部瀏覽器絕對不會有 token )

// CommunityUser 路人模式
// CommunityUserToken 會員模式
// * 變更權限: 會員搜尋只需要傳送裝置碼那個 token 就可以過了
const GetArticleList = (params) => axios.get(`${process.env.SmartlifeCoreApi}/v3.0/Committee/ComitteeArticleList_Anonymous`,{
  params
}).then(data => [null, data]).catch(err => [err, null])

const GetArticleDetail = (params) => axios.get(`${process.env.SmartlifeCoreApi}/v3.0/Committee/ComitteeArticleDetail`,{
  headers:{kingnetauth: `CommunityUser ${localStorage.getItem("v3token")}`},
  params
}).then(data => [null, data]).catch(err => [err, null])
// 無權限文章內容
const GetArticleDetail_Anonymous = (params) => axios.get(`${process.env.SmartlifeCoreApi}/v3.0/Committee/ComitteeArticleDetail_Anonymous`,{
  params
}).then(data => [null, data]).catch(err => [err, null])
// 收藏一定要有 token
const AddToFavorites = (data) => axios.put(`${process.env.SmartlifeCoreApi}/v3.0/Committee/AddToFavorites`, data,{
  headers:{kingnetauth: `CommunityUser ${localStorage.getItem("v3token")}`}
}).then(data => [null, data]).catch(err => [err, null])
// 推一定要有 token
const RecommendArticle = (data) => axios.put(`${process.env.SmartlifeCoreApi}/v3.0/Committee/RecommendArticle`, data,{
  headers:{kingnetauth: `CommunityUser ${localStorage.getItem("v3token")}`}
}).then(data => [null, data]).catch(err => [err, null])

export default {
    metaInfo () {
      return {
        title: this.pageTitle,
        titleTemplate: '%s充電站'
      }
    },
    components: { favoritesToast, v3favoritesToast },
    data () {
        return {
            pageTitle: '',
            closeOffline: false,
            appAlertDisplay: false,
            News:{},//新聞內容
            MoreNews:[],//相關文章列表
            MoreNewsRule:[],//新聞相對映法條
            scrollPrevioustTicks:0,
            fz_larg: false,
            hasToken: false,
            Authority: true,//false,
            MoreNews_row:11,
            toastControl:{
                show: false,
                full: false,
                content: '',
                showTime: 1000
            },
            v3Toast:{
                show: false,
                text: '',
                duration: 1000
            },
            toastTimer: null
        }
    },
    watch: {
        isOffline: function(val) {
            // 在下次無網路時再度打開上面的 top tip
            if (!val) this.closeOffline = false
        }
    },
    mounted(){
        this.CheckHasToken().then(() => {
            this.GetNewsDetail()
        })
        window.addEventListener('scroll', this.handleScroll);
    },
    methods:{
        backToApp() {
            document.location.href = `/#/v3newsDetail/${this.News.news_id}/?KNSTMethod=unbindMember`
        },
        closeOfflineHandle() {
            this.closeOffline = true
        },
        // 顯示 v3Toast
        showV3Toast(text) {
            clearTimeout(this.toastTimer)
            this.v3Toast.text = text;
            this.v3Toast.show = true;
            this.toastTimer = setTimeout(() => {
                this.v3Toast.show = false;
            }, this.v3Toast.duration);
        },
        // 底部功能表示窗滾動事件 ( 維持舊的 )
        handleScroll () {
            let scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();

            if(scrollBottom < 100 && this.MoreNews_row<=this.MoreNews.length && this.MoreNews.length >=10){
                this.ShowMoreNews()
            }

            if(this.scrollPrevioustTicks<window.scrollY){
                //向下滑動
                $('.qk-functionBar').removeClass('active')
                if(scrollBottom == 0){$('.qk-functionBar').addClass('active')}
            }else if(this.scrollPrevioustTicks>window.scrollY){
                //向上滑動
                $('.qk-functionBar').addClass('active')
            }
            this.scrollPrevioustTicks = window.scrollY;
        },
        //取得新聞詳細名單 ( 需判斷 token 有無 )
        async GetNewsDetail(){ // v3 調整

            let news_id = typeof this.$route.params.id == 'number' ?  this.$route.params.id :  decodeURIComponent(this.$route.params.id).split('-')[0]

            if (localStorage.getItem("v3token")) {
                // 可能有會員身份 , 但有被別人偽造的風險
                let [err, res] = await GetArticleDetail({newsid: news_id})

                if (err) console.warn('[GetArticleDetail ERROR]', err) // 觸發後準備降級到無權限 ＡＰＩ

                if (res) {
                    this.News = HanderDetailFormatFromAPI(res.data.Data)
                    this.pageTitle = this.News.title + ' | '
                    this.$gtm.trackView(this.News.title, this.$route.fullPath)
                    this.News['news_date']=this.News['news_date'].split(' ')[0].replace(/-/g, '/');
                    this.GetMoreNews();
                    this.GetNewsRule();
                    return
                }
            }
            // 降級處理
            this.Authority = false
            // localStorage.removeItem("CommunityUser")

            // 無會員身份 或 認證失敗被降級來這的
            let [err, res] = await GetArticleDetail_Anonymous({newsid: news_id})

            if (err) console.warn('[GetArticleDetail_Anonymous ERROR]', err)

            if (res) {
                this.News = HanderDetailFormatFromAPI(res.data.Data)
                this.pageTitle = this.News.title + ' | '
                this.$gtm.trackView(this.News.title, this.$route.fullPath)
                this.News['news_date']=this.News['news_date'].split(' ')[0].replace(/-/g, '/');
                this.GetMoreNews();
                this.GetNewsRule();
                return
            }
        },
        //取得相關的新聞列表
        async GetMoreNews(){ // v3 調整
            if (this.isOffline) {
                this.showV3Toast('網路狀態異常')
                return
            }
            //  舊有漏洞 : 拉升每次取值的數量, 達到“偽”下拉更新機制, 有著耗費流量這個缺點
            let [err, res] = await GetArticleList({MainTypeId: this.News.news_type, Quantity: this.MoreNews_row})
            if(err) console.warn('[GetArticleList ERROR]', err)
            if(res) {
                this.MoreNews = res.data.Data.Articles.map(HanderFormatFromAPI).filter(e => e.news_id !== +this.$route.params.id)
            }
        },
        //取的新聞的相對映法條  ( 維持舊的 )
        GetNewsRule(){
            let news_id = typeof this.$route.params.id == 'number' ?  this.$route.params.id :  decodeURIComponent(this.$route.params.id).split('-')[0]
            let vobj = this;
            this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetNewsDependLegalRule/${news_id}`,{
                headers:{Authorization: Token}
            }).then((response) => {
                if(response.status == 200){
                    this.MoreNewsRule =  response.data.data
                }
            }).catch(function (error) {
                // 以前留下來的迴圈, 不知道會什麼這樣寫
                // vobj.GetNewsRule();
            })
        },
        //設定收藏 v3 更動
        async SetFavorites(id,status){
            if (this.isOffline) {
                this.showV3Toast('網路狀態異常')
                return
            }
            let vobj = this;
            if(vobj.toastControl.show) return false

            let passApiData = {
                IsCheck: status ? 0 : 1,
                KeepIndex: id,
                KeepType: 0
            }
            let [err, res] = await AddToFavorites(passApiData)
            if (err) {
                console.warn('[AddToFavorites ERROR]', err)
                if (localStorage.getItem('v3appAuthLogin') !== 'true') {
                    this.appAlertDisplay = true
                } else {
                    document.location.href = `/#/v3newsDetail/${this.News.news_id}/?KNSTMethod=timeout`
                }

                this.Authority = false
                // ErrorMessage.Code 401000 檢查到非會員用戶
            }
            if(res){
                status ? vobj.UnfavoritesToast() : vobj.FavoritesToast()
                if(vobj.News['news_id'] === id) vobj.News['is_keep'] = !status
            }
        },
        //設定推 v3 更動
        async SetRecommend(id,status){
            if (this.isOffline) {
                this.showV3Toast('網路狀態異常')
                return
            }
            let vobj = this;
            let passApiData = {
                Status: 1,
                IsCheck: status ? 0 : 1,
                PushIndex: id,
                PushType: 0
            }
            let [err, res] = await RecommendArticle(passApiData)
            if (err) {
                console.warn('[AddToFavorites ERROR]', err)
                if (localStorage.getItem('v3appAuthLogin') !== 'true') {
                    this.appAlertDisplay = true
                } else {
                    document.location.href = `/#/v3newsDetail/${this.News.news_id}/?KNSTMethod=timeout`
                }
                this.Authority = false
                // ErrorMessage.Code 401000 檢查到非會員用戶
            }
            if(res){
                vobj.News['is_push'] = status ? (false):(true);
            }
        },
        //文字大小變化  ( 維持舊的 )
        ChanegSize(){
            this.fz_larg? this.fz_larg=false:this.fz_larg=true;
        },
        //分享按鈕
        Share(){
            document.location.replace(`/#/v3newsDetail/${this.News.news_id}/?KNSTMethod=share&title=${encodeURIComponent(this.News.title)}`)
            // let vm = this
            // let baseUrl = this.baseUrlHandle()

            // let copytext = `我在智生活看到【${this.News.title}】分享給你!｜生活充電站\n${baseUrl}/v3newsDetail/${this.News.news_id}`
            // this.$copyText(copytext).then(function (e) {
            //     vm.showV3Toast('已複製到剪貼簿')
            // }, function (e) {
            //     vm.showV3Toast('未能成功複製到剪貼簿')
            // })
        },
        baseUrlHandle() {
            switch(process.env.NODE_ENV) {
                case 'local':
                    return 'https://dist-dev.kingnetsmart.com.tw/#'
                case 'staging':
                    return 'https://dist-staging.kingnetsmart.com.tw/#'
                case 'prod':
                    return 'https://dist.kingnetsmart.com.tw/#'
                default:
                    return 'https://dist-dev.kingnetsmart.com.tw/#'
            }
        },
        //檢查權限
        CheckHasToken(){
            if(localStorage.getItem("v3token") === '' || localStorage.getItem("v3token") === null){
                this.hasToken = false
            }else{
                this.hasToken = true
            }
            return Promise.resolve()
        },
        //顯示更多相關新文
        ShowMoreNews(){
            this.MoreNews_row +=10;
            this.GetMoreNews();
        },
        //清空GotoNewsPage值
        CleanGotoNewsPage(news_type){
            if (this.isOffline) {
                this.showV3Toast('網路狀態異常')
                return
            }
            window.localStorage.setItem('GotoNewsPage','')
            document.location.href = '#/v3news/?news_type='+news_type
        },
        FavoritesToast(){
            this.toastControl.content = '已加入收藏'
            this.toastControl.full = true
            this.toastControl.show = true
        },
        UnfavoritesToast(){
            this.toastControl.content = '已取消收藏'
            this.toastControl.full = false
            this.toastControl.show = true
        },
        windowsOpen(url){
            if (this.isOffline) {
                this.showV3Toast('網路狀態異常')
                return
            }
            // 這裡的 API 有時會傳怪怪的東西過來, 注意格式及屬性
            let array = JSON.parse(url)
            window.open(array[0].link,'_system');
        },
        nextPage(id){
            if (this.isOffline) {
                this.showV3Toast('網路狀態異常')
                return
            }
            // this.$route.meta.keepAlive = false
            document.location.href = '#/v3newsDetail/'+id

            //如果為前往頁面時 需將頁面置頂 如為反回則照keepalive特性
            $('html,body').scrollTop(0);
        }
    },
    watch: {
        '$route' (to, from) {
            if(to.name === "v3newsDetail"){
                this.GetNewsDetail();
            }
        }
    },
    beforeRouteLeave (to, from, next) {
        const vm = this
        if(vm.isOffline){
            vm.showV3Toast('網路狀態異常')
        }else{
            next()
        }
    }
}
// !!!!!!!!!!!!!!!!!!!!!!!!!!!! 這是網頁版的充電站  ( 防止切來切去搞混 )
// * <p>!GOOGLE-AD?data-ad-layout="in-article"&data-ad-format="fluid"&data-ad-client="ca-pub-9449560331897859"&data-ad-slot="9862565468"</p>
function ad(contentArray) {
    if (contentArray[contentArray.length - 1] === 'AD') {
        return contentArray
    } else {
        let adIndex = contentArray[contentArray.length - 1].search('<p>!GOOGLE-AD')
        let adLength = contentArray[contentArray.length - 1].slice(adIndex).search('</p>')
        // let parameter = contentArray[contentArray.length - 1].slice(adIndex, adIndex + adLength)
        if (adIndex === -1) return contentArray
        let ar = [
            contentArray[contentArray.length - 1].slice(0, adIndex),
            // {
            //     "data-ad-layout": adurl(parameter, "data-ad-layout"),
            //     "data-ad-format": adurl(parameter, "data-ad-format"),
            //     "data-ad-client": adurl(parameter, "data-ad-client"),
            //     "data-ad-slot": adurl(parameter, "data-ad-slot")
            // },
            'AD',
            contentArray[contentArray.length - 1].slice(adIndex + adLength + 4)
        ]
        contentArray.pop()
        return ad(contentArray.concat(ar))
    }
}

function adurl(url, key) {
  if (url.indexOf('?') !== -1) {
    let ary = url.split('?')[1].split('&amp;')

    for (let i = 0; i <= ary.length - 1; i++) {
      if (ary[i].split('=')[0] === key) {
        return ary[i].split('=')[1]
      }
    }
  }
  return undefined
}

function HanderDetailFormatFromAPI (e) {
    return {
        about: e.About,
        abstract_note: e.Abstract_node,
        click_rate: e.ClickRate,
        content: ad([e.Content]),
        is_keep: e.IsKeep,
        is_push: e.IsPush,
        legal_id: e.LegalId,
        legal_logo: e.LegalLogo,
        legal_name: e.LegalName,
        multiLink: e.MultiLink,
        news_date: e.News_date,
        news_id: e.Id,
        news_type: e.MainTypeId,
        type_name: e.MainTypeName,
        news_subtype: e.SubTypeId,
        subtype_name: e.SubTypeName,
        push_count: e.Push,
        title: e.Title,
        title_img: e.Title_img
    }
}
function HanderFormatFromAPI(e) {
    return {
        news_id: e.Id,
        news_type: e.MainTypeName,
        news_typeId: e.MainTypeId,
        news_subType: e.SubTypeName,
        news_subTypeId: e.SubTypeId,
        title: e.Title,
        title_img: e.Title_img,
        abstract_note: e.AbstractNote
    }
}
</script>
<style lang="css">
.v3offline {
    position: fixed;
    z-index: 99;
    width: 100%;
    height: 44px;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 21px;
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    color: #fff;
    background: rgba(66, 137, 167, .9); /* #4289a7 2020/11/19 13:37 BD mean this color */
    -webkit-transition: .5s;
    transition: .5s;
}
.v3offline > i {
    margin-right: 9px;
    font-size: 19px;
    width: 19px;
    height: 19px;
}
.v3offline div {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 18px;
    width: 18px;
    height: 18px;
}
.v3Toast {
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 10px;
    transform: translate(-50%, -50%);
    line-height: 27px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    background: rgba(0,0,0,.7); /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    padding: 7px 10px 6px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    color: #fff;
    font-size: 15px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
    font-weight: 500;
}
#v3newsDetail .articleList ul {
    margin: 0px;
}
#v3newsDetail .articleList ul > li {
    padding: 18px 22px 18px 12px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
    width: 100%;
}
#v3newsDetail .articleList ul > li > a {
    padding: 0;
}
#v3newsDetail .articleList ul > li .articleTag {
    color: #00CCC0;
    align-self: flex-start;
    margin-bottom: 12px;
    background-color: #F3F3F3;
    padding: 0 8px 1px;
    font-size: 13px;
    border-radius: 13px;
    line-height: initial;
    display: inline-block;
}
#v3newsDetail .articleList ul > li .articleContent {
	  display: flex;
}
#v3newsDetail .articleList ul > li .articleContent .articleContentImg {
    height: 60px;
    width: 90px;
    border-radius: 4px;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #e8e8e8;
    background-position: center center;
}
#v3newsDetail .articleList ul > li .articleContent .articleContentNote {
    flex: 1;
    padding: 0 4px 0 12px;
    font-size: 16px;
    line-height: 20px;
    text-align: left;
    font-weight: bold; /* 2020/11/23 怎麼又要粗體了 */
    color: #484848;
    overflow: hidden;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
#v3newsDetail .articleList ul > li .articleContent .articleContentIcon {
    font-size: 18px;
    line-height: 18px;
    align-self: center;
    color: #00CCC0;
}
#v3newsDetail .articleList ul .articleListEmpty {
    width: 100%;
    height: calc(100vh - 44px - env(safe-area-inset-top, 20px) - 50px);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
    color: gray;
}
.appAlert {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #f7f7f7;
    border-radius: 8px;
    width: calc(100vw - 100px);
    z-index: 99;
}

.appAlertMask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: #04040F;
    opacity: .4;
    z-index: 98;
}

.appAlert .appAlertTitle {
    margin: 21px 0 24px 0;
    color: #484848;
    text-align: center;
    font-size: 20px;
}

.appAlert .appAlertNote {
    margin: 0px 0 25px 0;
    color: #484848;
    font-size: 16px;
    line-height: 21px;
    padding: 0 20px;
}

.appAlert .appAlertButton {
    font-size: 17px;
    display: flex;
    padding: 0 20px;
}

.appAlert .appAlertButton > span {
    border-top: 2px solid #d2d2d2;
    padding: 20px 0;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.appAlert .appAlertButton > span:nth-child(1) {
    color: #00CCC0
}

.appAlert .appAlertButton > span:nth-child(2) {
    color: #999
}

/* // ! 不良的修改方法  */
#v3newsDetail .cgy-tag {
    background-color: #F3F3F3;
    color: #00CCC0;
}

/* v3functionBar */

#v3functionBar.active {
    background: transparent;
    opacity: 1;
    bottom: 24px;
}

#v3functionBar [class|=qk-functionBar-wrap] {
    width: auto;
    margin: 0 8px;
    padding: 0 8px;
    border-radius: 23px;
    box-shadow: 0 3px 6px rgba(0,0,0,.2);
    background-color: #fff;
}

#v3functionBar [class|=qk-functionBar-wrap] div {
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: initial;
    height: 50px;
}
#v3functionBar [class|=qk-functionBar-wrap] span {
    font-size: 13px;
    color: #484848;
}

#v3functionBar [class|=qk-functionBar-wrap] div.active i {
    color: #00CCC0;
}

#v3functionBar [class|=qk-functionBar-wrap] div.active span {
    color: #00CCC0;
}
/* // ! 不良的修改方法  */
/* v3文章內容 */
#v3newsDetail .txtContent *:not(table, tr, td) {
    /* 使斜體、ul、ol、a 呈現出 reset 前的既有樣式 */
    all: revert;
}
#v3newsDetail .txtContent a {
    /* 使 a 呈現出客製化樣式 */
    color: #00CCC0;
    text-decoration-color: #00CCC0;
}
#v3newsDetail .txtContent table, tr, td {
    /* 使 table 呈現出 reset 前的既有樣式，border-width 直接 hard code 成 1px，border-color 可被覆寫 */
    border-width: 1px;
    border-style: solid;
    border-color: inherit;
}
#v3newsDetail .txtContent.LargSize {font-size: 21px;}
#v3newsDetail .detailWrap:nth-child(1) { padding: 16px 0 64px 0; position: relative; margin-bottom: 10px; position: relative; box-sizing: border-box; background-color: #fff; }
#v3newsDetail .detail-h { margin-bottom: 15px; padding: 0 16px; }
#v3newsDetail h3 { word-break: break-all;font-size: 21px; font-weight: bold; margin: 8px 0 10px; line-height: 1.4; padding-left: 0px; }
#v3newsDetail .article_date { color: #b0b0b0; font-size: 15px; line-height: 1.3; padding-left: 0px; }
#v3newsDetail .detail-h {margin-bottom: 10px;}
#v3newsDetail .txtContent { padding: 16px; line-height: 1.7; font-size: 17px; }
#v3newsDetail .txtContent p { word-break: break-all; }
#v3newsDetail .article_date { padding-left: 0px; color: #999;}

/* v3文章來源 */
#v3newsDetail .detail-source { position: relative; margin: 35px 20px 0px; padding: 15px 20px; line-height: 1.4; font-size: 16px; border: 1px solid #cecece; }
#v3newsDetail .detail-source h4 { position: absolute; font-size: 21px; font-weight: 600; display: block; top: -15px; left: 50%; margin-left: -57px; background-color: #fff; padding: 0 15px; }
#v3newsDetail .detail-source .logowrap .s-name { background: #00CCC0; width: 57%;; color: #fff; border-radius: 50em; font-size: 15px; font-weight: 600; padding: 4px 13px 2px; margin-bottom: 8px; text-align: center; position: relative; }
#v3newsDetail .detail-source .descwrap { font-size: 15px; line-height: 1.6; }

/* v3許願 */
#v3newsDetail .articleWrap .detail-c .questionnaire .img {display: table-cell;border-radius: 4px; padding: 11% 0%;width: 30%;display: table-cell;height: auto;background-repeat: no-repeat;background-size: cover;background-color: #e8e8e8;background-image: url(../../assets/questionnaire-02.png);background-position: 50%;}
#v3newsDetail .articleWrap .detail-c .questionnaire .txt {display: table-cell;width: 68%;display: table-cell;margin-right: 10px; font-size: 15px; padding: 0px 10px;color: #484848;}
#v3newsDetail .articleWrap .detail-c .questionnaire .txt .content {font-size: 13px; color: #999;line-height:16px;padding-top: 10px;}
</style>




// WEBPACK FOOTER //
// src/components/v3/newsDetail.vue